import { render, staticRenderFns } from "./LegalNotice.vue?vue&type=template&id=59001294&scoped=true&"
import script from "./LegalNotice.vue?vue&type=script&lang=ts&"
export * from "./LegalNotice.vue?vue&type=script&lang=ts&"
import style0 from "./LegalNotice.vue?vue&type=style&index=0&id=59001294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59001294",
  null
  
)

export default component.exports